<app-modal [customClass]="'confirmation-modal'" [noHeader]="true"  [strictClose]="true"  [showButton]="false" [adobestepname]="'homepage logout popup'" #logoutConfirmModal>
  <button type="button" class="close-modal" aria-label="Close" (click)="logoutConfirm(false)">
      <app-icon [icon]="Icon.Close"></app-icon>
  </button>
  <div class="popup-title" [innerHTML]="'LogoutConfirmation.Title' | translate | punctuationWrap"></div>

  <div class="sil-modal-CTA-wrapper col-xs-12">
      <button class="btn btn-secondary" (click)="logoutConfirm(false)" [innerHTML]="'LogoutConfirmation.CloseBtn' | translate | punctuationWrap"></button>
      <button class="btn btn-primary" (click)="logoutConfirm(true)" [innerHTML]="'LogoutConfirmation.OkBtn' | translate | punctuationWrap"></button>
  </div>
</app-modal>
